import React from "react";
import Modal from "react-modal";
import { useModalStore } from "../stores/use-modal"; // Import store Zustand

Modal.setAppElement("#root");

const InstructionModal = () => {
  const { isOpen, closeModal } = useModalStore(); // Lấy trạng thái modal từ store

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className="bg-background border border-primary  p-6 rounded-lg shadow-xl max-w-md mx-auto mt-20 "
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
    >
      <div className="flex flex-col items-center gap-4 text-center">
      <h2 className="text-xl font-bold font-[Pacifico]">Hướng dẫn</h2>
      <p>(1) Nhấn bắt đầu</p>
      <p>(2) Suy nghĩ về điều bạn đang phân vân, hoặc có thể nói thành tiếng</p>
      <p>(3) Nhấn chuột khi bạn đã sẵn sàng</p>
      <p>(4) Xem kết quả và suy ngẫm</p>


      </div>
      <div className="flex flex-col items-center gap-4 text-center">
      <h2 className="text-xl font-bold font-[Pacifico]">Lưu ý</h2>
      <p>Hãy đặt câu hỏi ở dạng lựa chọn</p>
      <p>Xin hãy tập trung khi đặt câu hỏi, yếu tố này ảnh hưởng đến độ chính xác</p>
      <p>Nếu lời giải đáp còn mơ hồ hay bạn muốn có thêm chỉ dẫn, hãy thử lại</p>

      </div>
      {/* <button onClick={closeModal} className="mt-4 px-4 py-2 bg-red-500 text-white rounded">
        Đóng
      </button> */}
    </Modal>
  );
};

export default InstructionModal;
